var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingBagGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0836 14.5834H9.88588L8.04293 33.75L31.9577 33.75L30.1147 14.5834H27.917V20C27.917 20.6904 27.3573 21.25 26.667 21.25C25.9766 21.25 25.417 20.6904 25.417 20V14.5834L14.5836 14.5834V20C14.5836 20.6904 14.024 21.25 13.3336 21.25C12.6433 21.25 12.0836 20.6904 12.0836 20V14.5834ZM14.6191 12.0834L25.3815 12.0834C25.094 9.73519 23.0928 7.91669 20.667 7.91669H19.3336C16.9078 7.91669 14.9066 9.73519 14.6191 12.0834ZM27.8938 12.0834H30.3418C31.5011 12.0834 32.4706 12.9641 32.5815 14.118L34.4725 33.7847C34.5996 35.1063 33.5606 36.25 32.2329 36.25L7.76773 36.25C6.44 36.25 5.40098 35.1063 5.52806 33.7847L7.41909 14.118C7.53004 12.9641 8.49954 12.0834 9.65876 12.0834H12.1068C12.4038 8.35205 15.5259 5.41669 19.3336 5.41669H20.667C24.4747 5.41669 27.5968 8.35206 27.8938 12.0834Z",
    fill: "#636363"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBagGrey);
export default __webpack_public_path__ + "static/media/shopping-bag-grey.a9462512.svg";
export { ForwardRef as ReactComponent };